// extracted by mini-css-extract-plugin
export default {"fieldset":"Anthropometry_fieldset__X+INj","select":"Anthropometry_select__Qi2no"};